import { jsx, Fragment } from 'react/jsx-runtime';

const Switch = ({ active, children }) => {
    // Varre todas as opções filhas passadas e retorna a que está ativa
    return (jsx(Fragment, { children: children.filter(child => {
            return String(child.key) === String(active);
        }) }));
};

export { Switch };
